import { defineMessage } from 'services/localization';

export const messages = {
    enableReviewStep: defineMessage('enable_review_step'),
    billMatchingDescription: defineMessage('review_step_allows_to_m_em_with_purchase_orders'),
    description: defineMessage('review_step_allows_to_m_changes_to_templatename'),
    hide: defineMessage('hide'),
    enable: defineMessage('enable'),
};
